import { useEffect, useState } from "react"

export const useWindowResize = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(typeof window !== "undefined" ? window.innerWidth > 768 : false)

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      const newValue = width > 768

      if (newValue !== isLargeScreen) {
        setIsLargeScreen(newValue)
      }
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [isLargeScreen])

  return isLargeScreen
}
